import * as React from 'react';
import { List, Datagrid, TextField, ReferenceField } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { Tabs, Tab, Divider } from '@material-ui/core';
import Filter from './filter';
import Pagination from '../pagination';
import { ImageField } from '../fields';

const datagridStyles = {
  total: { fontWeight: 'bold' },
};

class TabbedDatagrid extends React.Component {
  tabs = [
    { id: 'category', name: 'Categories' },
    { id: 'subcategory', name: 'SubCategories' },
  ];

  state = { category: [], subcategory: [] };

  static getDerivedStateFromProps(props, state) {
    if (props.ids !== state[props.filterValues.type]) {
      return { ...state, [props.filterValues.type]: props.ids };
    }
    return null;
  }

  handleChange = (event, value) => {
    const { filterValues, setFilters } = this.props;
    setFilters({ ...filterValues, type: value });
  };

  render() {
    const { classes, filterValues, ...props } = this.props;
    return (
      <>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.type}
          indicatorColor="primary"
          onChange={this.handleChange}
        >
          {this.tabs.map((choice) => (
            <Tab
              key={choice.id}
              label={choice.name}
              value={choice.id}
            />
          ))}
        </Tabs>
        <Divider />
        {filterValues.type === 'category' && (
          <Datagrid rowClick="edit" {...props} ids={this.state['category']}>
            <TextField source="id" />
            <TextField source="status" />
            <ImageField source="preview_image_url" width="60" />
            <TextField source="name" />
            <TextField label="Last Modified" source="updatedAt" />
          </Datagrid>
        )}
        {filterValues.type === 'subcategory' && (
          <Datagrid rowClick="edit" {...props} ids={this.state['subcategory']}>
            <TextField source="id" />
            <TextField source="status" />
            <ImageField source="preview_image_url" width="60" />
            <ReferenceField source="parent_id" reference="categories">
              <TextField source="name" />
            </ReferenceField>
            <TextField source="name" />
            <TextField label="Last Modified" source="updatedAt" />
          </Datagrid>
        )}
      </>
    );
  }
}

const StyledTabbedDatagrid = withStyles(datagridStyles)(TabbedDatagrid);

const CategoryList = ({ classes, ...props }) => (
  <List
    {...props}
    filterDefaultValues={{ type: 'category' }}
    sort={{ field: 'name', order: 'ASC' }}
    pagination={<Pagination />}
    perPage={100}
    filters={<Filter permissions={props.permissions} />}
  >
    <StyledTabbedDatagrid />
  </List>
);

export default CategoryList;
